import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import VueRouter from "vue-router";
import Vuex from "vuex";
import Vuetify from "vuetify/lib";
import { shellRoutes, routerBeforeEachFn } from "./router";
import { getShellState } from "./store";
import "./styles/app.scss";
import messenger from "./plugins/axios";
import dayjs from "./plugins/dayjs";
import commons from "./plugins/common";
import getAuth from "./auth";

import { mdiEmail } from "@mdi/js";

const getProp = require("dotprop");

const defaultmanageShellState = function(isLoggedIn, commit /*user, axios*/) {
  /*
    Available mutations ( <mutation_name>, <payload> )
    'shell/SET_FULL_NAME', <str:full_name>
    'shell/SET_EMAIL', <str:email>
    'shell/SET_PICTURE', <str:picture_url>
    'shell/SET_SWITCHABLE_ORGANIZATIONS', <Array: organization_array>
    'shell/SET_CURRENT_ORGANIZATION_NAME', <str:name>
    'shell/SET_CURRENT_ORGANIZATION_ID', <str/number:id>
    'shell/SET_CURRENT_ORGANIZATION_PERMISSIONS', <Array: permission_string>
    'shell/CLEAR_ORGANIZATION_DATA', <NO PAYLOAD>
  */

  if (isLoggedIn) {
    commit("shell/SET_FULL_NAME", "DEFAULT NAME");
    commit("shell/SET_EMAIL", "borad@boradorg.com");
    commit(
      "shell/SET_PICTURE",
      "https://core.realhrsoft.com/media/cache/b9/9d/b99d5bb58572765cbf35b45d11652d82.png"
    );
    commit("shell/SET_SWITCHABLE_ORGANIZATIONS", [
      {
        name: "Aayulogic",
        slug: "aayulogic"
      }
    ]);
    commit("shell/SET_CURRENT_ORGANIZATION_NAME", "Aayulogic");
    commit("shell/SET_CURRENT_ORGANIZATION_ID", "aayulogic");
    commit("shell/SET_CURRENT_ORGANIZATION_PERMISSIONS", []);
    commit("shell/SET_USER_ORGANIZATION_NAME", "Aayulogic");
    commit("shell/SET_USER_ORGANIZATION_ID", "aayulogic");
  } else {
    commit("shell/CLEAR_ORGANIZATION_DATA");
  }
};

export default function(options) {
  // options.sidebarItems = require('./utils/sidebar/normalUser.js')

  const sidebarItems = require("./utils/sidebar").sidebarItems;
  // import {sidebarItems} from './utils/sidebar'

  options.sidebarItems = options.sidebarItems || sidebarItems;

  options.userData = {
    manageShellState:
      getProp(options, "userData.manageShellState") || defaultmanageShellState
  };

  Vue.prototype.$shellOptions = options;
  // logo must be inline
  window.rhrCoreShellOptions = {
    logo: options.logo ? options.logo : require("./assets/logo.svg"),
    name: options.name || "RealHRSoft",
    slogan: options.slogan || "Complete HR Technology",
    loginUserLabel: options.loginUserLabel || "Email",
    loginUserFieldName: options.loginUserFieldName || "email",
    loginUserAppendIcon: options.loginUserAppendIcon || mdiEmail,
    permissionGetterName: options.permissionGetterName,
    appBarAfterSpacer:
      options.appBarAfterSpacer ||
      // TODO @wrufesh does later is required and included in bundle if former is true
      require("./layouts/AppBarAfterSpacer.vue").default,
    layouts: {
      ErrorLayout: require("./layouts/ErrorLayout.vue").default,
      EmptyLayout: require("./layouts/EmptyRouterView.vue").default,
      DefaultLayout: require("./layouts/Default.vue").default,
      AccountLayout: require("./layouts/Account.vue").default,
      ...options.layouts
    }
  };

  Vue.use(Vuetify);
  let vuetify = new Vuetify({
    ...{
      icons: {
        iconfont: "mdiSvg"
      }
    },
    ...(options.vuetifyOptions || {})
  });

  Vue.use(dayjs);
  Vue.use(commons);

  Vue.use(Vuex);
  let store = new Vuex.Store({
    modules: {
      shell: getShellState(),
      ...(options.storeModules ? options.storeModules : {})
    }
  });

  Vue.use(VueRouter);

  // START override duplicate routes
  let optionsRoutes = options.routes || [];

  let appendUrlWithSlash = function(url) {
    return url.endsWith("/") ? url : `${url}/`;
  };

  let filteredShellRoutes = shellRoutes.filter(shellRoute => {
    let match = optionsRoutes.find(optionsRoute => {
      return (
        appendUrlWithSlash(shellRoute.path) ===
        appendUrlWithSlash(optionsRoute.path)
      );
    });
    return !match;
  });
  const router = new VueRouter({
    mode: "history",
    // routes: [...shellRoutes, ...(options.routes || [])]
    routes: [...optionsRoutes, ...filteredShellRoutes]
  });
  // END override duplicate routes

  if (options.beforeRouteCallback) {
    // TODO @wrufesh change beforeRouteCallback to beforeRouteCallbackFnGetter
    router.beforeEach(options.beforeRouteCallback(store));
  } else {
    router.beforeEach(routerBeforeEachFn(store));
  }

  const authOptions = options.authOptions;

  Vue.config.productionTip = false;

  Vue.prototype.$axios = messenger;

  const auth = getAuth(authOptions, {
    $axios: messenger,
    store,
    route: router.resolve(
      window.location.pathname + window.location.search + window.location.hash
    ).route,
    router,
    redirect: (path, query) => {
      console.log(query); //eslint-disable-line
      router.push(path);
    }
  });

  window.$auth = auth;

  auth.init().then(() => {
    store.watch(
      () => store.state.auth.loggedIn,
      loggedIn => {
        options.userData.manageShellState(
          loggedIn,
          store.commit,
          store.state.auth.user,
          messenger
        );
      },
      {
        immediate: true
      }
    );

    Vue.prototype.$auth = auth;

    if (!auth.loggedIn && auth.options.autoLoginOIDCStrategy) {
      auth.strategies[
        auth.options.autoLoginOIDCStrategy
      ].setAutoLoginUniversal();
    }

    Vue.prototype.$rhrCoreShellOptions = window.rhrCoreShellOptions;

    new Vue({
      store,
      router,
      vuetify,
      render: h => h(App)
    }).$mount("#app");
  });

  // Store for layout and props
  const layoutStore = Vue.observable({
    layoutName: "",
    props: {}
  });

  const layoutMutations = {
    updateLayout(layoutName) {
      layoutStore.layoutName = layoutName;
    },
    updateProps(props) {
      layoutStore.props = props;
    }
  };

  router.beforeEach((to, from, next) => {
    const layoutName = to.meta.layout || "DefaultLayout";
    layoutMutations.updateLayout(layoutName);
    next();
  });

  function resolveError(obj) {
    layoutMutations.updateLayout("ErrorLayout");
    layoutMutations.updateProps(obj);
  }

  Vue.prototype.layoutStore = layoutStore;

  return {
    Vue,
    vuetify,
    store,
    router,
    options,
    $axios: messenger,
    resolveError
  };
}

export { default as FormValidator } from "./utils/form_validator";
